import { Trans, useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { ProgressLinear } from '@mint-lib/tw-components/patterns';
import { cn } from '@mint-lib/tw-utils';

export const FileValidationView = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <>
      <Trans
        i18nKey={
          "<Typography>The <bold>system automatically checks</bold> your file's structure and data types. If validation succeeds, you can import your media plan. If errors are found, download the error log and upload a corrected file.</Typography>"
        }
        t={t}
        components={{
          Typography: (
            <span
              className={cn(
                typographyVariants({ variant: 'bodyLong01' }),
                'my-6',
              )}
            />
          ),
          bold: <span className="font-bold" />,
        }}
      />
      <div className="my-15 flex w-full items-center gap-2">
        <div className="w-full">
          <ProgressLinear determinate={false} />
        </div>
        <span className={typographyVariants({ variant: 'label01' })}>
          {t('Validation')}
        </span>
      </div>
    </>
  );
};
